/**
 * International travel Urls
 */

export const BaseUrl = `/travel/api/v1/international`;
export const BaseUrlV2 = `/travel/api/v2/travel/journey`;

export const VisaBaseUrl = `/travel/api/v1/vas/visa_assistance`;

export const V2fBaseUrl = `${VisaBaseUrl}/v2f`;

export const TravelFeBaseUrl = `/p/travel/international-insurance`;

export const TravelPassBaseUrl = `/travel/api/v1/travel`;

export const TravelFePdpUrl = `${TravelFeBaseUrl}/pdp`;

export const VasFeBaseUrl = `/travel/vas/visa-application`;

export const TravelPassFeBaseUrl = `/travel/domestic-pass`;

export const JourneyType = {
  PURCHASE: 'purchase',
  TRAVEL_PASS: 'travel_pass_purchase',
  INTERNATIONAL_TRAVEL: 'international-travel',
};

export const UrlType = {
  FETCH_JOURNEY: '',
  FETCH_FAQS: '/faqs',
  SELECT_PACKAGE: '/select_package',
  EDIT_TRIP_DETAILS: '/edit_trip_details',
  UPDATE_COVER: '/plan',
  UPDATE_TRAVELLER_DETAILS: '/update_traveller_details',
  CHECK_PINCODE: '/check-pincode',
  UPDATE_BUNDLED_ADDONS: '/addons',
  INITIATE_PAYMENT: '/initiate_payment',
  KYC_INIT: '/kyc/init',
  VERIFY_PAYMENT: '/payment_verify',
  UPDATE_INSURED: '/update_insured',
  SUBMIT_USER_DETAILS: '/submit_user_details',
};

export const travelV2fUrls = {
  initV2fJourney: () => {
    const url = `${V2fBaseUrl}/journey/init`;
    return url;
  },
  getV2fCountries: () => {
    const url = `${V2fBaseUrl}/countries`;
    return url;
  },
  v2fCountryResults: () => {
    const url = `${V2fBaseUrl}/countries/result`;
    return url;
  },
  initPayment: () => {
    const url = `${V2fBaseUrl}/journey/payment/init`;
    return url;
  },
  verifyPayment: (bookingId: string, ekey: string) => {
    const url = `${V2fBaseUrl}/journey/payment/verify?booking_id=${bookingId}&ekey=${ekey}`;
    return url;
  },
  initInsurancePurchase: (bookingId: string) => {
    const url = `${VisaBaseUrl}/${bookingId}/insurance_purchase/init`;
    return url;
  },
  getMyBookings: () => {
    const url = `${V2fBaseUrl}/applications`;
    return url;
  },
};

export const travelPassUrls = {
  initJourney: `${TravelPassBaseUrl}/journey/${JourneyType.TRAVEL_PASS}/purchase/init`,
  fetchJourney: (jId: string) => `${TravelPassBaseUrl}/journey/${jId}/fetch`,
  submitUserDetails: (jId: string) =>
    `${TravelPassBaseUrl}/journey/${jId}${UrlType.SUBMIT_USER_DETAILS}`,
  updateState: (jId: string, action: string) =>
    `${TravelPassBaseUrl}/journey/${jId}/goto/${action}`,
  manageCustomerAddress: `${TravelPassBaseUrl}/address`,
  putCustomerAddress: `${TravelPassBaseUrl}/address`,
  fetchUserDetails: `${TravelPassBaseUrl}/get_pass_policy`,
};

export const internationalTravelUrlsV2 = {
  initJourney: `${BaseUrl}/journey/${JourneyType.PURCHASE}/init/v2`,
  action: (jId: string, action: string) => {
    const url = `${BaseUrl}/journey/${JourneyType.PURCHASE}/${jId}${action}/v2`;
    return url;
  },
  updateState: (jId: string, action: string) => {
    const url = `${BaseUrl}/journey/${JourneyType.PURCHASE}/${jId}/goto/${action}`;
    return url;
  },
};

export const internationalTravelUrls = {
  initJourney: `${BaseUrl}/journey/${JourneyType.PURCHASE}/init`,
  initJourneyV2: `${BaseUrlV2}/${JourneyType.INTERNATIONAL_TRAVEL}/purchase/init`,
  getSeoData: `${BaseUrl}/seo/insurance_purchase/config`,
  initSeoJourney: `${BaseUrl}/seo/insurance_purchase/init`,
  fetchPreExistingDiseases: `${BaseUrl}/medical/pre-existing-diseases`,
  getAllTrips: `travel/api/v1/travel/my_trips`,
  action: (jId: string, action: string) => {
    const url = `${BaseUrl}/journey/${JourneyType.PURCHASE}/${jId}${action}`;
    return url;
  },
  updateState: (jId: string, action: string) => {
    const url = `${BaseUrl}/journey/${JourneyType.PURCHASE}/${jId}/goto/${action}`;
    return url;
  },
  getBenefits: (jId: string, planId: string) => {
    const url = `${BaseUrl}/${jId}/covers?planId=${planId}`;
    return url;
  },
  verifyPayment: (proposalId: string) => {
    const url = `${BaseUrl}/proposal/${proposalId}/payment_verify`;
    return url;
  },
  cancelTransaction: () => {
    const url = `${BaseUrl}/proposal/cancel_transaction`;
    return url;
  },
  generic: (type: string) => {
    const url = `${BaseUrl}${type}`;
    return url;
  },
  getComparison: (jId: string, req: string) => {
    const url = `${BaseUrl}/journey/${jId}/plans/compare?${req}`;
    return url;
  },
  getPdp: (policyId) => {
    const url = `${BaseUrl}/policy-details/compressed/${policyId}`;
    return url;
  },
  getPdpUrl: () => `${BaseUrl}/claim/pdp`,
  applyCoupon: () => `${BaseUrl}/apply_coupon`,
  removeCoupon: () => `${BaseUrl}/remove_coupon`,
  getPsuedoCoupon: (isApp = false) => {
    const platform = isApp ? 'app' : 'web';
    const url = `${BaseUrl}/pseudo-coupons?platform=${platform}`;
    return url;
  },
  getPolicyPdf: (policyId = '') => {
    const url = `${BaseUrl}/pdf?policy_id=${policyId}`;
    return url;
  },
  postPurchaseDataCollection: (jId: string) => {
    const url = `${BaseUrl}/journey/${jId}/post_purchase_data_collection`;
    return url;
  },
};

export const CoverType = {
  MEDICAL: 'medical',
  TRIP: 'trip',
  BAGGAGE: 'baggage',
};

export const getUserDetailsAPI = `/api/user/details/`;

/**
 * partnership urls
 */

export const partnershipUrls = {
  claim: {
    claimDetails: `jarvis-api/partnership/claims/oneclick/internet/data`,
    trackingDetails: {
      partnership: `jarvis-api/partnership/claims/internet`,
      electronics: `electronics-api/fetch/claims/tracking`,
    },
  },
  onboarding: {
    policyDetails: `partnership/user/onboarding/policy_details`,
    updateUserDetails: `partnership/user/onboarding/user_details`,
    updateCarDetails: `partnership/user/onboarding/crosssell_details`,
  },
  policy: {
    details: 'partnerships/fetch/policy',
  },
  claims: {
    partnershipClaims: 'partnerships/fetch/claims',
    electronicsClaims: 'electronics-api/fetch/claims',
  },
};

export const electronicsUrls = {
  policy: {
    details: 'electronics-api/fetch/policy',
    edit: 'electronics-api/policy',
  },
};

export const partnershipsUrls = {
  demoRequest: `/partnerships/send_lead_email`,
};

export const userUrls = {
  basicDetails: `https://www.acko.com/api/user/details/`,
};
